import {AnyAction} from 'redux';
import {
    BRONTO,
    CART,
    CATEGORY,
    CHECKOUT,
    CUSTOMER,
    MONTHLY_PAYMENTS,
    NEWSLETTER,
    PRODUCT,
    PROFILE,
    QUOTE_ITEM,
    SEARCH_RESULTS,
} from 'constants/actions';

const ACTIONS_TO_KEEP_ERRORS = [
    PRODUCT.GET_DISCOUNT_PRICE,
    'SAVE_ADDRESSES_INFO',
    'SEND_FORGOT',
    CUSTOMER.SEND_REGISTRATION,
    CART.LAUNCH_ADDING_TO_CART,
    'CART_QUICK_ADD_TO_CART',
    QUOTE_ITEM.GET_ITEMS,
    'SET_CURRENT_SHIPPING_ADDRESS',
    'SET_CURRENT_BILLING_ADDRESS',
    'FETCH_COUNTRIES',
    CHECKOUT.SET_ACTIVE_PAYMENT,
    CHECKOUT.SAVE_ORDER,
    'POST_PURCHASE_INSURANCE_PLACE_ORDER',
    'POST_PURCHASE_INSURANCE_COLLECT_TOTALS',
    MONTHLY_PAYMENTS.GET_DATA,
    CART.GET_PAYMENT_BUTTONS,
    'CHECKOUT_SAVE_PAYMENT',
    'GET_CMS_BLOCK_BY_ID',
    PROFILE.SAVE_ACCOUNT_EDIT,
    SEARCH_RESULTS.GET_SEARCH_RESULTS,
    CATEGORY.GET_FILTERS_CATEGORY,
    CATEGORY.GET_CATEGORY_ITEMS_COUNT,
    CATEGORY.GET_CATEGORY_ITEMS,
    NEWSLETTER.SUBSCRIBE,
    BRONTO.SUBSCRIBE,
    BRONTO.EMAIL_CAPTURE,
];

/**
 * Handle rejected requests
 * @returns {Function} - dispatch initial action
 */
export const errorMiddleware = <T extends AnyAction>() => (next: (arg: T) => Promise<T>) => (
    action: T,
) => {
    if (action.payload instanceof Promise && !ACTIONS_TO_KEEP_ERRORS.includes(action.type)) {
        return next(action).catch(error => error);
    }
    return next(action);
};
